import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AppUnderTest from './pages/appundertest/AppUnderTest';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<AppUnderTest />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
